import { assign } from 'xstate';

import { getStateKey } from '../../../helpers/getStateKey';
import { getStates } from '../../../helpers/getStates';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';

type State = {
  state: {
    value: any;
    context: ProductBuilderMachineContext;
  };
};

export const updateCustom = assign(
  (
    context: ProductBuilderMachineContext,
    event: ProductBuilderMachineEvent,
    state: State | any,
  ) => {
    if (event.type !== 'UPDATE_CUSTOM') return context;

    const states = getStates(context);
    const stateKey = getStateKey(state.state.value);
    const stateIndex = states.indexOf(stateKey);
    let resetStates = {};

    if (
      context.custom[stateKey] &&
      event.custom[stateKey] !== context.custom[stateKey]
    ) {
      states.forEach((el, index) => {
        if (index <= stateIndex) return;
        // Don't reset wand_option, wand_colour, trackRequire, and trackColour as they should persist across navigation
        if (el === 'wand_option' || el === 'wand_colour' || el === 'trackRequire' || el === 'trackColour') return;
        resetStates = {
          ...resetStates,
          [el]: undefined,
        };
      });
    }

    const custom = {
      ...context.custom,
      ...event.custom,
      ...resetStates,
    };

    return { ...context, custom };
  },
);
